/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Settings/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Settings({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/Settings"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let providerAccountStatusValueData = fromData.useDataValue({ viewPath,
context: 'provider_account',
path: 'status',
})
let providerAccountProviderValueData = fromData.useDataValue({ viewPath,
context: 'provider_account',
path: 'provider',
})
let aggregateData = fromHelpers.getView(providerAccountStatusValueData, providerAccountProviderValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}